import { ServiceItem } from "../../../../services/framework/serviceitem";
import { Tile } from "../../widgets/tile/tile.component";

export interface ApplicationItem extends ServiceItem {
  text: string;
  imageUrl: string;
  actionUrl: string;
  routerLink: string;
  loginRequired: ApplicationLoginRequired;
  sortOrder: number;
  isActive?: boolean;
  tile: Tile;
  target?: string;
  surveyId?: string;
}

export interface ISessionKey {
  key: string;
}

export enum ApplicationLoginRequired {
  PassThrough = 0,
  PIResearch = 1
}
